var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.405%",
    y1: "20.817%",
    x2: "76.16%",
    y2: "64.748%",
    id: "l7gkyb38ba"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A",
    offset: ".8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE3D4A",
    offset: "44.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52030",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.495%",
    y1: "44.155%",
    x2: "81.31%",
    y2: "88.069%",
    id: "itz2pv3blb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE9F2",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9EA7B0",
    offset: "99.8%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16H0c0 8.837 7.163 16 16 16s16-7.163 16-16z",
    fill: "url(#l7gkyb38ba)",
    transform: "rotate(-180 16 16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.163 0 0 7.163 0 16h32c0-8.837-7.163-16-16-16z",
    fill: "url(#itz2pv3blb)",
    transform: "rotate(-180 16 16)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.55dd7d6796fbf0db6682945db0729fed.svg";
export { ForwardRef as ReactComponent };